import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  categoryName: string;
  cover: string;
  rating: number;
  views: number;
  chapters: number;
  status: string;
  tags: string[];
}

export default function ComicCard({
  id,
  title,
  author,
  categoryName,
  cover,
  rating,
  views,
  chapters,
  status,
  tags,
}: ComicCardProps) {
  const formattedViews = views >= 10000 ? `${(views / 10000).toFixed(1)}万` : views.toString();

  return (
    <Link
      to={`/comic/${id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className="inline-block px-2 py-0.5 bg-primary-500 text-white text-xs rounded-md whitespace-nowrap">
            {rating}
          </span>
        </div>
        {status === '连载中' && (
          <div className="absolute top-2 right-2">
            <span className="inline-block px-2 py-0.5 bg-accent-500 text-white text-xs rounded-md whitespace-nowrap">
              连载
            </span>
          </div>
        )}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <p className="text-white text-xs whitespace-nowrap">
            <i className="ri-eye-line mr-1"></i>{formattedViews} 阅读
          </p>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
        {title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">
        {author} · {categoryName} · 共{chapters}话
      </p>
      <div className="flex items-center gap-1.5 mt-2 flex-wrap">
        {tags.slice(0, 2).map((tag) => (
          <span
            key={tag}
            className="inline-block px-2 py-0.5 bg-secondary-100 text-secondary-800 text-xs rounded-md whitespace-nowrap"
          >
            {tag}
          </span>
        ))}
      </div>
    </Link>
  );
}